module.exports = __webpack_public_path__ + "img/burner-mining-drill-W.941fc266.png";